/**
 * Zephyr fix: dt-theme.js's productVariantCallback() and dt_QuickCallback()
 * read variant.featured_media.id, but Shopify's product JSON only exposes
 * variant.featured_image (not featured_media). That mismatch throws a
 * silent JS error on every variant change, which aborts all the code that
 * runs after it in that function -- price, SKU, and the Add to Cart /
 * "Sold Out" button state never update after the first click.
 *
 * This file is loaded after the (build-generated, non-editable) dt-theme.js
 * and overrides the two affected functions with a corrected copy.
 *
 * NOTE: the gallery-image-swap step is intentionally NOT reimplemented here.
 * The product gallery (snippets/thumbnails.liquid) now handles syncing its
 * image to the selected variant independently, by watching the page URL.
 * Duplicating that logic here would risk two systems fighting over the same
 * slider. Everything else (price, SKU, stock, Add to Cart button state) is
 * restored to work exactly as the original theme intended.
 */
(function () {
  function applyFix() {
    if (!window.theme || !window.theme.ProductPage || !window.theme.ProductPage.prototype) {
      return false;
    }

    var proto = window.theme.ProductPage.prototype;

    proto.productVariantCallback = function (variant, selector) {
      if (variant) {
        this.ProductStatus.updateContent(variant.id);
      }
      if (variant && window.UrlTrigger) {
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
      }

      var buy_now_btn = jQuery(this.settings.selectors.addToCart).closest('form').find('.shopify-payment-button');

      if (variant) {
        var indexArray = [];
        jQuery('.main-product-select-' + selector + ' .single-option-selector option:selected').each(function () {
          indexArray.push(jQuery(this).index());
        });
        var form = jQuery('#ProductSelect-' + selector).closest('form');
        for (var i = 0, len = variant.options.length; i < len; i++) {
          var num = indexArray[i];
          var radioButtonDiv = form.find('.swatch[data-option-index="' + i + '"] div.swatch-element')[num];
          var radioButton = jQuery(radioButtonDiv).find(':radio');
          if (radioButton.length) {
            radioButton.get(0).checked = true;
          }
        }
      }

      if (variant) {
        jQuery(this.settings.selectors.productPrice).html(Shopify.formatMoney(variant.price, DT_THEME.moneyFormat));

        if (variant.unit_price && typeof window.setUnitPrice === 'function') {
          jQuery(this.settings.selectors.unitPrice).html(window.setUnitPrice(variant));
        } else {
          jQuery(this.settings.selectors.unitPrice).html('');
        }

        if (variant.compare_at_price > variant.price) {
          jQuery(this.settings.selectors.comparePrice).html(Shopify.formatMoney(variant.compare_at_price, DT_THEME.moneyFormat)).removeClass('hide');
          jQuery(this.settings.selectors.price).addClass(this.settings.selectors.saleClasses);
          jQuery(this.settings.selectors.saleLabel).removeClass('hide');
          jQuery(this.settings.selectors.comparePrice).closest('li').removeClass('hide');
        } else {
          jQuery(this.settings.selectors.comparePrice).addClass('hide');
          jQuery(this.settings.selectors.comparePrice).closest('li').addClass('hide');
          jQuery(this.settings.selectors.saleLabel).addClass('hide');
          jQuery(this.settings.selectors.price).removeClass(this.settings.selectors.saleClasses);
        }

        if (variant.available) {
          jQuery(this.settings.selectors.notifyForm).hide();
          jQuery(this.settings.selectors.addToCart).prop('disabled', false);
          jQuery(this.settings.selectors.addToCartText).text(DT_THEME.strings.addToCart);
          buy_now_btn.show();
        } else {
          jQuery(this.settings.selectors.notifyForm).show();
          jQuery(this.settings.selectors.addToCart).prop('disabled', true);
          jQuery(this.settings.selectors.addToCartText).text(DT_THEME.strings.soldOut);
          buy_now_btn.hide();
        }

        var variantSkuData = jQuery(this.settings.selectors.variantSkuData);
        var variantSku = jQuery(this.settings.selectors.variantSku);
        var InventoryProduct = jQuery(this.settings.selectors.InventoryProduct);
        var variantInventory = jQuery(this.settings.selectors.variantInventory);

        if (variant.sku && variantSkuData.length) {
          variantSkuData.addClass('attributes-visible').removeClass('attributes-hidden');
          variantSku.html(variant.sku);
          if (variantSkuData.is(':last-child')) {
            variantSkuData.prev('li').removeAttr('style');
          }
        } else {
          variantSkuData.addClass('attributes-hidden').removeClass('attributes-visible');
          variantSku.html('');
          if (variantSkuData.is(':last-child')) {
            variantSkuData.prev('li').css('padding-bottom', '0');
          }
        }

        if (InventoryProduct.length) {
          InventoryProduct.addClass('attributes-visible').removeClass('attributes-hidden');
          var main_product_select = jQuery('#ProductSelect-' + selector);
          var optionsLength = main_product_select.find('option').length;
          var variant_inventory_management = '';
          var variant_inventory_policy = '';
          var variant_inventory_quantity = '';
          for (var oi = 0; oi <= optionsLength; oi++) {
            var currentOption = main_product_select.find('option:nth-child(' + oi + ')');
            if (currentOption.val() == variant.id) {
              variant_inventory_management = currentOption.attr('data-inventory_management');
              variant_inventory_policy = currentOption.attr('data-inventory_policy');
              variant_inventory_quantity = currentOption.attr('data-inventory_quantity');
              break;
            }
          }
          if (variant_inventory_management == 'shopify' && variant_inventory_policy != 'continue') {
            if (variant_inventory_quantity > 0) {
              variantInventory.html('<span class=in-stock>In stock!</span>');
              jQuery('.dt-sc-qty').show();
            } else {
              variantInventory.html('<span class=out-of-stock> Out of stock.</span>');
              jQuery('.dt-sc-qty').hide();
            }
          } else {
            variantInventory.html('<span class=in-stock>In stock!</span>');
            jQuery('.dt-sc-qty').show();
          }
        }

        this.$container.find('.product-price').show();
        jQuery(this.settings.selectors.addToCart).show();
        this.$container.find('.product_payments_btns').show();
        if (variant.available) {
          jQuery(this.settings.selectors.addToCart).prop('disabled', false);
          jQuery('.dt-sc-qty').show();
        }
      } else {
        this.$container.find('.product-price').show();
        this.$container.find('.product_payments_btns').show();
        jQuery(this.settings.selectors.addToCart).prop('disabled', true);
        jQuery(this.settings.selectors.addToCartText).text(DT_THEME.strings.unavailable);
        jQuery(this.settings.selectors.comparePrice).addClass('hide');
        jQuery(this.settings.selectors.comparePrice).closest('li').addClass('hide');
        jQuery(this.settings.selectors.saleLabel).addClass('hide');
        jQuery(this.settings.selectors.price).removeClass(this.settings.selectors.saleClasses);
        jQuery(this.settings.selectors.productPrice).html('Unavailable');
        buy_now_btn.hide();
        jQuery('.dt-sc-qty').hide();
        jQuery(this.settings.selectors.notifyForm).show();
      }
    };

    if (typeof window.dt_QuickCallback === 'function') {
      window.dt_QuickCallback = function (variant, selector) {
        var productPanel = jQuery('div.quick-shop-modal[data-id="' + selector + '"]');

        if (variant) {
          var indexArray = [];
          jQuery("[data-id='" + selector + "'] .single-option-selector option:selected").each(function () {
            indexArray.push(jQuery(this).index());
          });
          var form = jQuery('#dt-sc-quick-ProductSelect-' + selector).closest('form');
          for (var i = 0, len = variant.options.length; i < len; i++) {
            var num = indexArray[i];
            var radioButtonDiv = form.find('.swatch[data-option-index="' + i + '"] div.swatch-element')[num];
            var radioButton = jQuery(radioButtonDiv).find(':radio');
            if (radioButton.length) {
              radioButton.get(0).checked = true;
            }
          }
        }

        var addToCart = productPanel.find('.dT-AddtoCart');
        var addtoCartText = addToCart.find('span');
        var productPrice = productPanel.find('.product-price-current span');
        var unitPrice = productPanel.find('.unitPrice');
        var comparePrice = productPanel.find('.product-price-list span');

        if (variant) {
          if (variant.available) {
            addToCart.removeClass('disabled').prop('disabled', false).val('Add to Cart');
            addtoCartText.text('Add to Cart');
          } else {
            addToCart.val('Sold Out').addClass('disabled').prop('disabled', true);
            addtoCartText.html('Sold Out');
          }
          if (variant.unit_price && typeof window.setUnitPrice === 'function') {
            unitPrice.html(window.setUnitPrice(variant));
          } else {
            unitPrice.html('');
          }
          if (productPrice.length) {
            productPrice.html(Shopify.formatMoney(variant.price, DT_THEME.moneyFormat));
          }
          if (comparePrice.length) {
            if (variant.compare_at_price > variant.price) {
              comparePrice.html(Shopify.formatMoney(variant.compare_at_price, DT_THEME.moneyFormat)).show();
              comparePrice.closest('li').show();
            } else {
              comparePrice.html('');
              comparePrice.closest('li').hide();
              comparePrice.hide();
            }
          }
          productPanel.find('.product-price').show();
          addToCart.show();
          productPanel.find('.product_payments_btns').show();
          if (variant.available) {
            addToCart.prop('disabled', false);
          }
        } else {
          addToCart.val('Unavailable').show().addClass('disabled').prop('disabled', true);
          addtoCartText.html('Sold Out');
          comparePrice.html('');
          comparePrice.closest('li').hide();
          comparePrice.hide();
          productPrice.html('Unavailable');
          productPanel.find('.product-price').show();
          productPanel.find('.product_payments_btns').show();
        }
      };
    }

    return true;
  }

  // dt-theme.js has already loaded by the time this script runs (it's placed
  // after it in the page), so try immediately. Retry briefly as a safety net
  // in case script order ever changes.
  if (!applyFix()) {
    var attempts = 0;
    var retry = setInterval(function () {
      attempts++;
      if (applyFix() || attempts > 20) {
        clearInterval(retry);
      }
    }, 50);
  }
})();
